export default "__VITE_ASSET__dd3807e1__"